import axios from 'axios'
import { baseURL, REST_SLUG, TRestaurantData } from 'models'
import useSWR, { SWRConfiguration } from 'swr'
type TDisabledDay = {
  createdAt: string
  date: string
  expireAt: string
  restaurant: string
  updatedAt: string
  __v: number
  _id: string
}
export const useGetRestaurants = (config?: SWRConfiguration) => {
  const fetchRest = async () => {
    try {
      const res = await axios<TRestaurantData[]>(
        baseURL + `/api/restaurants?showHidden=true`,
      )

      return res
    } catch (e) {
      throw Error
    }
  }
  const { data, isLoading, mutate } = useSWR('getRestaurants', fetchRest, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    ...config,
  })
  const restaurant = data?.data?.find(el => el.slug === REST_SLUG)
  return { isLoading, mutate, restaurant }
}

export const useGetDisabledDays = (restaurant?: string) => {
  const getDays = async (res: string) => {
    const { data } = await axios.get<TDisabledDay[]>(
      `${baseURL}/api/bookingDisabledDates?restaurant=${res}&perPage=366`,
    )
    return data
  }

  const { data, mutate, isLoading } = useSWR(
    restaurant ? ['disabled-days', restaurant] : null,
    ([, r]) => getDays(r),
    { revalidateOnFocus: false },
  )
  const disabledDays = data?.map(el => el.date)
  return { data, mutate, isLoading, disabledDays }
}
